import { render, staticRenderFns } from "./material-details.vue?vue&type=template&id=5c85ef9a&"
import script from "./material-details.vue?vue&type=script&lang=js&"
export * from "./material-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports